var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error404 d-flex justify-center align-center"},[_c('vue-headful',{attrs:{"title":"Страница не найдена","description":"Страница не найдена"}}),_c('div',[_vm._v("Страница не найдена")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }